<template>
	<section
		:class="{
			'bg-gray-600': isCurrent,
		}"
	>
		<header class="flex items-center justify-between px-12">
			<h2 class="text-gray-350 text-sm uppercase pt-8 pb-4 whitespace-nowrap overflow-hidden text-ellipsis">
				{{ workspace.name }}
			</h2>
			<BaseTooltip v-if="subscriptionProblemMessage" :text="subscriptionProblemMessage" placement="right">
				<BaseIcon name="mono/warn" class="text-yellow-500 cursor-help" />
			</BaseTooltip>
		</header>

		<CollectionSelectItem
			v-for="collection of sortedCollections"
			ref="collectionSelectItem"
			:key="collection.id"
			:collection="collection"
			:selectedCollection="selectedCollection"
			@select="$emit('select', collection)"
		/>

		<hr class="border-gray-650 mt-4 my-0" />
	</section>
</template>

<script>
import CollectionSelectItem from 'shared/components/CollectionSelectItem.vue'
export default {
	name: 'CollectionSelectWorkspaceItem',
	components: {
		CollectionSelectItem,
	},
	props: {
		workspace: {type: Object, required: true},
		selectedCollection: {type: Object, required: true},
		popoverVisible: Boolean,
		showConfirmation: Boolean,
	},
	emits: ['select'],
	computed: {
		isCurrent() {
			return this.workspace.id === this.$store.workspace.id
		},
		sortedCollections() {
			const collections = [...this.workspace.collections].sort(
				(a, b) => a.workspaceCollectionUsers[0].order - b.workspaceCollectionUsers[0].order
			)
			const unarchivedCollections = collections.filter(collection => !collection.archived)
			const archivedCollections = collections.filter(collection => collection.archived)
			// Don't allow to upload new sessions to archived collections...
			if (this.$store.isExtension) return unarchivedCollections
			// ... but allow to move sessions to archived collections
			return [...unarchivedCollections, ...archivedCollections]
		},
		subscriptionProblem() {
			return this.$workspaceSubscription.getProblem(this.workspace)
		},
		subscriptionProblemMessage() {
			const problem = this.$workspaceSubscription.getProblem(this.workspace)
			if (!problem) {
				return null
			}
			switch (this.subscriptionProblem) {
				case 'trial-ended':
					return 'Trial ended'
				case 'subscription-ended':
					return 'Subscription ended'
				case 'subscription-paused':
					return 'Subscription paused'
				case 'free-plan-ended':
					return 'Free plan ended'
				default:
					return null
			}
		},
	},
	watch: {
		async popoverVisible(popoverVisible) {
			if (!popoverVisible) return
			await this.$nextTick()
			// scroll either currently selected collection into view, or origin if one, for users with many workspaces & collections
			const componentWithRefs = this.$refs.collectionSelectItem?.filter(
				component => Object.keys(component.$refs).length > 0
			)
			this.showConfirmationButton
				? componentWithRefs[0]?.$refs.originCollection?.scrollIntoView({block: 'center'})
				: componentWithRefs[0]?.$refs.selectedCollection?.$el?.scrollIntoView({block: 'center'})
		},
	},
}
</script>
